import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import { AppShell } from './AppShell';
import { ProtectedRoute } from './ProtectedRoute';
import { LoginPage } from '@/features/auth/LoginPage';
import { AttentionPage } from '@/pages/AttentionPage';
import { BookingsPage } from '@/pages/BookingsPage';
import { ClientsPage } from '@/pages/ClientsPage';
import { DialogsPage } from '@/pages/DialogsPage';
import { AccountPage } from '@/pages/AccountPage';
import { AgentPage } from '@/pages/AgentPage';
import { IntegrationsPage } from '@/pages/IntegrationsPage';
import { KbPage } from '@/pages/KbPage';
import { PendingActionsPage } from '@/pages/PendingActionsPage';
import { PropertiesPage } from '@/pages/PropertiesPage';
import { SetupPage } from '@/pages/SetupPage';
import { PlaceholderPage } from '@/pages/PlaceholderPage';

function ShellLayout() {
  return (
    <ProtectedRoute>
      <AppShell>
        <Outlet />
      </AppShell>
    </ProtectedRoute>
  );
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  {
    element: <ShellLayout />,
    children: [
      { path: '/', element: <Navigate to="/attention" replace /> },
      { path: '/attention', element: <AttentionPage /> },
      { path: '/dialogs', element: <DialogsPage /> },
      { path: '/dialogs/:guestId', element: <DialogsPage /> },
      { path: '/bookings', element: <BookingsPage /> },
      { path: '/bookings/:id', element: <BookingsPage /> },
      { path: '/clients', element: <ClientsPage /> },
      { path: '/clients/:id', element: <ClientsPage /> },
      { path: '/properties', element: <PropertiesPage /> },
      { path: '/properties/:id', element: <PropertiesPage /> },
      { path: '/kb', element: <KbPage /> },
      { path: '/kb/documents/:id', element: <KbPage /> },
      { path: '/integrations', element: <IntegrationsPage /> },
      { path: '/agent', element: <AgentPage /> },
      { path: '/pending-actions', element: <PendingActionsPage /> },
      { path: '/account', element: <AccountPage /> },
      { path: '/setup', element: <SetupPage /> },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
